// File: App.js
import React from 'react';
import { GiBullseye } from "react-icons/gi";
import { FaRegEye } from "react-icons/fa";
import { FaRegGem } from "react-icons/fa";
import ScrollReveal from '../../components/ScrollReveal';
import { useLanguage } from '../../contexts/LanguageContext';


type SectionProps = {
    icon: React.ReactNode;
    title: string;
    description: string;
};

const Section: React.FC<SectionProps> = ({ icon, title, description }) => (
    <div className="flex flex-col items-center text-center max-w-xs mx-auto">
        <div className="text-[#1DB233] text-6xl">{icon}</div>
        <h2 className="text-2xl  text-[#ffffff] font-poppins font-semibold mt-4">{title}</h2>
        <p className="text-[#ffffff]/60 mt-2">{description}</p>
    </div>
);
const Objectives = () => {
    const { tString } = useLanguage();
    return (
        <section
            className="w-screen flex items-center justify-center  px-16 py-12"
            style={{
                backgroundColor: '#282A2A',
                backgroundImage: `
                    radial-gradient(ellipse 80% 60% at center, transparent 100%, #282A2A 80%),
                    url('/images/pattern.png')
                `,
                backgroundSize: 'auto',
                backgroundRepeat: 'repeat',
            }}
        >
            <div className="w-screen flex items-center justify-center py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 px-4">
                    <ScrollReveal direction="up" delay={0.2}>
                        <Section
                            icon={<GiBullseye />}
                            title={tString('objectives.missionTitle')}
                            description={tString('objectives.missionDescription')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="up" delay={0.4}>
                        <Section
                            icon={<FaRegEye />}
                            title={tString('objectives.visionTitle')}
                            description={tString('objectives.visionDescription')}
                        />
                    </ScrollReveal>
                    <ScrollReveal direction="up" delay={0.6}>
                        <Section
                            icon={<FaRegGem />}
                            title={tString('objectives.principlesTitle')}
                            description={tString('objectives.principlesDescription')}
                        />
                    </ScrollReveal>
                </div>
            </div>
        </section>
    );
};

export default Objectives;